import React, { FC, memo, useEffect } from 'react';
import Featured from '../../../../components/withTimerDesign/featured';
import SafetyAssurance from '../../../../../../UI/common/safetyAssurance';
import GetMyPlanBlock from '../../../../components/getMyPlanBlock';
import Reviews from '../../../../components/withTimerDesign/reviews';
import Description from '../../../../components/withTimerDesign/description';
import SpecialFeatures from '../../../../components/specialFeatures';
import MainScreen from 'modules/paywall/components/withTimerDesign/mainScreen';
import Plan from 'modules/paywall/components/withTimerDesign/plan';
import { appStore } from '@store';
import { Padding } from 'UI';

interface Props {
	children: React.ReactElement;
}

function getEmailInUrl(queryString: string) {
	const emailKey = 'email=';
	let startIndex = queryString.indexOf(emailKey);

	if (startIndex === -1) {
		// Ключ 'email=' не найден, возвращаем пустую строку
		return '';
	}

	startIndex += emailKey.length;
	const endIndex = queryString.indexOf('&', startIndex);
	const emailValue =
		endIndex === -1
			? queryString.substring(startIndex)
			: queryString.substring(startIndex, endIndex);

	return emailValue;
}

export const PaywallLayoutMailSingle: FC<Props> = memo(props => {
	const { children } = props;
	const { setEmailInApplication, paymentStore } = appStore;
	const { safetyAssurance, mailSingleV4 } = appStore.paymentStore.settings;
	const emailInUrl = getEmailInUrl(appStore.sourceLocation.search);
	paymentStore.setBraintreeVersion(true);

	useEffect(() => {
		if (emailInUrl) {
			setEmailInApplication(emailInUrl);
		}
	}, []);

	return (
		<Padding bottom={20}>
			{children}
			<Padding left={20} right={20}>
				{safetyAssurance && <SafetyAssurance />}
				<GetMyPlanBlock />
			</Padding>
			{mailSingleV4 && (
				<>
					<MainScreen />
					<Padding left={20} right={20}>
						<Plan />
					</Padding>
				</>
			)}
			<SpecialFeatures />
			<Padding left={20} right={20}>
				<Reviews />
				<Featured />
				<Description />
			</Padding>
		</Padding>
	);
});
